module.exports = __webpack_public_path__ + "img/foooter-shape-st-3.5a0fc065.png";